/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import layers from "./layers.js";
import styles from "./styles.js";

function showLayer(map, options) {
  options = {
    minZoom: 10,
    featureColor: function (feature) {
      var sharedSite;
      if(options.sharedSiteLookup) {
        sharedSite = options.sharedSiteLookup(feature.id);
      }
      return styles.sharedSiteColor(sharedSite);
    },
    ...(options || {})
  };

  var newOptions = {
    ...options,
    polygonStyle: function (feature, state, defaultStyle) {
      var style = {
        fillColor: options.featureColor(feature),
        zIndex: 100,
        fillOpacity: state.highlight ? 0.6 : 0.3
      };

      return options.polygonStyle ? options.polygonStyle(feature, state, style) : style;
    },
    lineStyle: function(feature, state, defaultStyle) {
      var style = {
        strokeColor: options.featureColor(feature),
        zIndex: 100,
        strokeWeight: 2
      };

      return options.lineStyle ? options.lineStyle(feature, state, style) : style;
    },
    markerStyle: function(feature, state, defaultStyle) {
      return {
        icon: styles.sharedSiteMarkerIcon(),
        zIndex: 100,
        optimized: false
      };
    }
  };

  return layers.showLayer(map, birdata.sharedSiteTiles, newOptions);
}

export default {
  showLayer: showLayer
};
